
<template>

  <v-app>
    <notifications group="foo" />
  <v-navigation-drawer permanent app  :width="drawerwidth" >
      <v-img :src="logo" class="logo"  :height="47" contain/>        
      <v-list  style="padding:0px" dense>
      <v-divider></v-divider>

      <div v-for="(item,i) in menu" :key="i+'menu'" >
        <v-list-tile @click="openlink(item.path)" :class="way==item.way?'back':''" v-if="checkmenu(item)" >
          <v-list-tile-action>
            <img :src="item.img" style="width:30px;margin-left:4px" alt="">
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="font-weight-bold" :class="way==item.way?'fwhite':'fblue'" >{{item.name}}</v-list-tile-title>
          </v-list-tile-content>          
        </v-list-tile>
        <v-divider></v-divider>
      </div>
      
      </v-list>
  </v-navigation-drawer>


    <v-toolbar  fixed  class="back" dense app>
    <v-icon @click="changewidth" style="color:white">dashboard</v-icon>
     <v-toolbar-title style="color:white">Welcome {{convertcase(user.UserName) || 'Guest'}}</v-toolbar-title> 
          <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn flat v-if="user.length!=0"  style="color:white" class="subheading">₹&nbsp;{{balance}}</v-btn>        
      <v-btn flat v-if="user.length==0"  style="color:white" @click="$router.push('/account')"><v-icon >person</v-icon> &nbsp; Login</v-btn>        
      <v-menu offset-y v-else >
      <v-btn slot="activator" flat  style="color:white"><v-icon >person</v-icon> &nbsp;Account</v-btn>
      <v-list>
        <v-list-tile  @click="$router.push('/setting')" >
          <v-list-tile-title>Profile</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="logout" >
          <v-list-tile-title>Log Out</v-list-tile-title>
        </v-list-tile>
      </v-list>
      </v-menu>
   </v-toolbar-items>
  </v-toolbar>
   <v-content style="background:#f0f0f0;overflow: auto!important">
    <v-container fluid style="overflow: auto!important">
      <Login v-if="user.length==0"/> 
      <div v-else>
      <Progress v-if="check"/>
       <router-view v-else ></router-view>
      </div>
          <vue-snotify></vue-snotify>

    </v-container>
  </v-content>
  
  <v-footer  style="background:#1976D2">
     <v-spacer></v-spacer>
       <v-card-actions class="justify-center" style="color:white">
        &copy; 2019 - Developed By <strong> &nbsp;Bonrix Software Systems.</strong>
      </v-card-actions></v-footer>        
</v-app>

</template>

<script>
import Progress from './components/Progress.vue'
import Login from './pages/Login.vue'
export default {
  name: 'App',
  data () {
    return {
      drawerwidth:220,
      drawer:false,
      way:'billpay',
      check:true,
      menu:[
            {name:'Recharge',img:require("./assets/recharge.png"),way:"billpay",path:"/"},
            {name:'Downline',img:require("./assets/downline.png"),way:"downline",path:"/downline"},
            {name:'Recharge Inquiry',img:require("./assets/childlist.png"),way:"recharge",path:"/recharge"},
            {name:'Balance Transfer',img:require("./assets/transaction.png"),way:"transaction",path:"/transaction"},
            {name:'Last Transactions',img:require("./assets/success.svg"),way:"lasttransaction",path:"/lasttransaction"},
            {name:'Accounting Reports',img:require("./assets/report.png"),way:"report",path:"/report"},
            {name:'Commission',img:require("./assets/commission.png"),way:"commission",path:"/commission"},
            {name:'Offers',img:require("./assets/offer.png"),way:"offer",path:"/offer"},
            {name:'Complaints',img:require("./assets/complaint.png"),way:"complaint",path:"/complaint"},
            {name:'Payment Request',img:require("./assets/request.png"),way:"request",path:"/request"},
            {name:'Outstanding',img:require("./assets/outstanding.png"),way:"outstanding",path:"/outstanding"},
            {name:'Settings',img:require("./assets/setting.png"),way:this.getsetting().replace("/",""),path:this.getsetting()},
            {name:'Supports',img:require("./assets/support.png"),way:"support",path:"/support"},
            {name:'Download App',img:require("./assets/google.png"),way:"download",path:"/download"},
           ]
    }
  },

  beforeMount(){
      let vm = this;
      vm.$store.dispatch("getuser");      
      if(vm.user.length!=0){
        let doc={
                        PinNo:vm.user.pin,
                        MobileNo:vm.user.phone
                        }
                vm.$store.dispatch("axios",{
                        url:"Authentication",
                        data:doc,
                }).then(function (res) {
                        let doc = res.data;                        
                        if(doc.Status=="True"){
                            vm.check = false; 
                        }else{
                            vm.logout()
                            vm.check = false; 
                        }
                }).catch(function (error) {
                        vm.logout()
                        vm.check = false;
                        
                })
                
      }else{
        vm.check = false
      }
      
  },
  computed:{
      user(){
        return this.$store.getters.user;
      },
      balance(){
        return this.$store.getters.balance;
      },
      items(){
        return this.$store.getters.quickpay;
      },
      logo(){
        return this.$store.getters.logo;
      },
      details(){
        return this.$store.getters.details
      }
  },
  watch:{
     $route (to, from){
          this.way = to.name;
     },
     items(value){
        console.log(this.items)
     }
  },
  methods:{
    checkmenu(item){
      let vm = this;
      if(vm.user.Type=="Admin" && item.name=="Recharge")return false
      if(vm.user.Type=="MasterDistributor" && item.name=="Recharge")return false
      if(vm.user.Type=="Distributor"  && item.name=="Recharge")return false
      if(vm.user.Type=="Dealer"  && item.name=="Downline")return false
      return true;
    },
    getsetting(){
      let user = localStorage.user;
      if(user){
       return  "/setting"
      }
       return  "/account"
    },
    convertcase(value){
      if(value!=null){
        value = value.toUpperCase()
      }
      return value
    },
    logout(){
      let vm = this;
      localStorage.removeItem("user");
      window.location.reload();
    },
    changewidth(){
        let vm = this;
        if(vm.drawerwidth==220){
          let width = window.innerWidth-310-153+"px"
          vm.$store.commit("setrwidth",width)
          vm.drawerwidth = 70;
        }else{
          vm.drawerwidth = 220;
          let width = window.innerWidth-310-303+"px"
          vm.$store.commit("setrwidth",width)
        }
    },
    fetchdata(){
          let vm = this;
          if(vm.user.length!=0){
              let ldoc = {PinNo:vm.user.pin,MobileNo:vm.user.phone,PageSize:25};
              vm.$store.dispatch("axiosget",{url:"LastTransaction", data:ldoc,way:"setlasttrans"})
          }
    },
    fetchsettings(){
      let vm = this;
      let domain = vm.getdomainname( window.location.hostname);
      let doc = {DomainName:domain};
      vm.$store.dispatch("axios",{url:"WhiteLableDetails", data:doc}).then(function (res) {
        let doc = [];
        let value = res.data.Data;
        if(value==null)return;
        if(value.Details!=null){
          doc.details = value.Details       
        }
        if(value.BannerImages.LoginLogo!=null){
          doc.logo = value.BannerImages.LoginLogo       
        }
        if(value.BankDetails!=null){
          doc.bankdetails = value.BankDetails        
        }
        vm.$store.commit("setdetails",doc);
      }).catch(function (error) {
      })
    },
    openlink(link){
      let vm = this;
      if(link!="/download"){         
        vm.$router.push(link)
      }else{
         let win = window.open(vm.details.PlayStoreUrl, '_blank');
         win.focus();

      }
    },
    getdomainname(domain){
      let vm = this;
      let split = domain.split(".")
      if(split.length>2){
        domain = split[1]+"."+split[2];
      }
      return domain;
    }

  },
  components: {
    Login,
    Progress
  },
  mounted(){
      let vm = this;
      vm.way = vm.$route.name;  
      vm.$store.dispatch("getbalance") 
      let interval = localStorage.interval
      if(interval==null){
        interval = 30
      }
      setInterval(function () {
          if(vm.way=="billpay"){
             vm.fetchdata();            
          }
      }, 1*interval*1000);
      let height = window.innerHeight - 200;
      let v_table = document.getElementsByClassName('v-table__overflow');
      for(let i =0;i<v_table.length;i++){
          v_table[i].style.height=height+"px"
      }
   //  vm.fetchsettings();
  }
}
</script>

<style >
table tr td{
  white-space: nowrap;
  padding:0px!important;
  height: 35px!important;
  padding-left:10px!important;
  padding-right: 15px!important;
}
table tr th{
  padding:0px!important;
  height: 20px!important;
  padding-left:10px!important;
  padding-right: 15px!important;
}
table.v-table tbody td {
    border-right: 1px solid lightgray;
}
.v-table__overflow{
    overflow: auto!important;
}
</style>

